var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupMenuAllCalendarsOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 8.56512C15.3334 8.56512 15.0775 9.32165 14.4464 10.2493C14.2837 10.4686 13.7293 11.5081 12.1251 12.5201C11.0729 13.1791 9.7183 13.6452 8.00008 13.6176C2.40607 13.5278 0.666748 8.56512 0.666748 8.56512C0.666748 8.56512 1.47484 6.03158 3.87508 4.4905C4.62654 4.00803 6.04446 3.4787 7.08341 3.38063C7.37667 3.3495 7.68207 3.33301 8.00008 3.33301C13.6646 3.33301 15.3334 8.56512 15.3334 8.56512Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00024 10.1963C8.94948 10.1963 9.71899 9.44078 9.71899 8.5088C9.71899 7.57681 8.94948 6.82129 8.00024 6.82129C7.051 6.82129 6.28149 7.57681 6.28149 8.5088C6.28149 9.44078 7.051 10.1963 8.00024 10.1963Z",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMenuAllCalendarsOn);
export default __webpack_public_path__ + "static/media/group_menu_all_calendars_on.7e874246ef398ea4b66ac6f5ca8260ab.svg";
export { ForwardRef as ReactComponent };